const formatter = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "symbol",
  });

const getEuro = (number:number):string => formatter.format(number);

export default getEuro;